import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import AOS from "aos";
import { Helmet } from "react-helmet";
import styled from "styled-components";
// import Finalnav from '../../page/Homepages/Finalnav';
// import Footer from '../../page/Homepages/Footer';
import Breadcrumb from "../Breadcrumb";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";

const BlogDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isShowMore, setIsShowMore] = useState(false);

  useEffect(() => {
    AOS.init(); // Initialize AOS
  }, []);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/blogs/${slug}`
        );
        setBlog(response.data);
        setLoading(false);
      } catch (err) {
        if (err.response && err.response.status === 404) {
          //   navigate('/blogslist');
          // Redirect to blog list if not found
        } else {
          setError("Failed to load blog");
        }
        setLoading(false);
      }
    };

    fetchBlog();
    window.scrollTo(0, 0);
  }, [slug, navigate]);

  const handleFooterLink = () => {
    window.scrollTo(0, 0);
  };

  const toggleReadMoreLess = () => {
    setIsShowMore(!isShowMore);
  };

  if (loading)
    return (
      <Wrapper>
        <BannerSectionStyle3
          bgUrl="/images/about/AboutBanner_bg.jpeg"
          // imgUrl="/images/about/banner_img.png"
          title="Welcome to <br /> Pluro Jabalpur<br /> Fertility Center"
          subTitle="Understanding the Psychological and Lifestyle Aspects"
        />
        <div className="container text-center my-5">
          <h3>Loading...</h3>
        </div>
      </Wrapper>
    );
  if (error)
    return (
      <div className="container text-center my-5">
        <h3>{error}</h3>
      </div>
    );
  if (!blog) return null;

  return (
    <>
      {/* <Finalnav /> */}
      <Helmet>
        <title>{blog.meta_title || `${blog.title} | Pluro Jabalpur Fertility Centre`}</title>
        <meta name="description" content={blog.meta_description} />
        <meta name="keywords" content={blog.meta_keywords} />
        <meta name="author" content={blog.author || "Pluro Jabalpur Fertility Center"} />
        <link
          rel="canonical"
          href={blog.canonical_url || `https://plurojabalpurivfcentre.com/blogs/${blog.slug}`}
        />
      </Helmet>
      <Wrapper>
        <BannerSectionStyle3
          bgUrl="/images/about/AboutBanner_bg.jpeg"
          // imgUrl="/images/about/banner_img.png"
          title="Welcome to <br /> Pluro Jabalpur<br /> Fertility Center"
          subTitle="Understanding the Psychological and Lifestyle Aspects"
        />
        {/* <Breadcrumb /> */}
        <div className="container">
          <div className="container">
            <h2 className="mt-5 text-center">{blog.title}</h2>
            <div
              className="underline mx-auto"
              style={{
                height: 3,
                width: "4rem",
                backgroundColor: "#171717",
                marginTop: 25,
                marginBottom: 10,
              }}
            ></div>
            <div className="text-center blog-meta mt-3 d-flex justify-content-center align-items-center flex-wrap gap-3">
              <span className="blog-author text-dark fw-semibold">
                <i className="fa fa-user me-1 text-primary"></i> Author: {blog.author || "Pluro Jabalpur Fertility Center"}
              </span>
              {blog.category && (
                <span className="badge bg-light text-primary border">
                  {blog.category}
                </span>
              )}
              <span className="blog-date text-muted">
                Published: {new Date(blog.published_date).toLocaleDateString()}
              </span>
              {blog.updated_date && blog.updated_date !== blog.published_date && (
                <span className="blog-updated text-muted">
                  Updated: {new Date(blog.updated_date).toLocaleDateString()}
                </span>
              )}
            </div>
          </div>

          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-12 text-center">
                <div data-aos="fade-right">
                  {blog.image_url && (
                    <img
                      src={ `https://jabalpurivfcentre.com/${
                        blog.image_url || "uploads/1743677335230-704855352.jpg"
                      }`}
                      alt={blog.image_alt || blog.title || "Default Image"}
                      className="frontimg rounded-5"
                    />
                  )}
                </div>
              </div>

              <div className="col-lg-12 mt-3">
                <div className="content-div" data-aos="fade-left">
                  <div className="blog-content" />
                  <p dangerouslySetInnerHTML={{ __html: blog.content }}></p>
                </div>
                <hr />
              </div>

              {/* Author Card Box */}
              <div className="col-lg-12 mt-3 mb-5">
                <div className="p-4 rounded-3 bg-light border d-flex flex-column flex-md-row align-items-center gap-3">
                  <div className="author-avatar flex-shrink-0">
                    <img
                      src="/images/about/about_doctor.png"
                      alt={blog.author || "Pluro Jabalpur Fertility Center"}
                      className="rounded-circle shadow-sm"
                      style={{ width: "80px", height: "80px", objectFit: "cover" }}
                      onError={(e) => { e.target.style.display = 'none'; }}
                    />
                  </div>
                  <div className="text-center text-md-start">
                    <h5 className="mb-1" style={{ color: "#f58220" }}>
                      {blog.author || "Pluro Jabalpur Fertility Center"}
                    </h5>
                    <p className="mb-0 text-muted" style={{ fontSize: "0.92rem" }}>
                      Dedicated to providing world-class fertility care, advanced IVF/ICSI treatments, and compassionate guidance to help couples achieve their dream of parenthood.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </Wrapper>
      {/* <Footer /> */}
    </>
  );
};

export default BlogDetail;

const Wrapper = styled.div`
  button {
    background-color: #f58220;
  }
  button:hover {
    background-color: #f58220;
  }
  .img3 {
    margin-top: 1rem;
    margin-left: -2rem;
    @media screen and (max-width: 768px) {
      margin-left: -8rem;
    }
    @media screen and (min-width: 768px) and (max-width: 1020px) {
      height: 30rem;
      margin-left: -1rem;
      margin-top: -3rem;
    }
  }

  h2 {
    font-size: 34px;
    color: #8a4aa8;
    @media screen and (max-width: 768px) {
      font-size: 1.4rem;
    }
  }

  p {
    color: #666666;
    text-align: justify;

    @media screen and (max-width: 768px) {
      font-size: 1rem;
    }
  }
  h5 {
    font-size: 20px;
    color: #8a4aa8; //card
    margin-top: 2rem;
    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }
  li {
    margin-bottom: 0.5rem;
  }
  ul {
    list-style: none;
  }
  .frontimg {
    // width: 20rem;
    /* width: 60rem; */
    // height: 50%;
    width: 100%; /* Make it scale with parent */
    max-width: 60rem; /* Keep large size on big screens */
    height: auto; /* Maintain aspect ratio */
    margin: 1rem auto; /* Center horizontally */
    display: block;
    @media screen and (max-width: 768px) {
      height: 15rem;
      width: 100%;
      margin-top: -4rem;
    }
    @media screen and (min-width: 768px) and (max-width: 1020px) {
      height: 20rem;
      width: 100%;
      margin-top: -4rem;
    }
  }
  #more {
    width: 10rem;
    margin: 0.5rem;
    color: white;
  }

  .th {
    font-weight: bold;
  }
  .mleft {
    margin-left: 2rem;
  }

  .blog-meta {
    color: #666666;
    font-size: 0.9rem;
    margin-bottom: 1rem;
  }

  .content-div {
    /* width: 60rem;
    border: 2px solid black;
    padding: 2rem;
    border-radius: 2rem;
    margin: 0.5rem 0; */
    width: 100%; /* Responsive width */
    max-width: 60rem; /* Prevent stretching too wide */
    border: 2px solid black;
    padding: 2rem;
    border-radius: 2rem;
    margin: 0.5rem auto;
  }

  .blog-content {
    color: #666666;
    text-align: justify;

    h5 {
      font-size: 20px;
      color: #8a4aa8;
      margin-top: 2rem;
    }

    ul {
      list-style: none;
      padding-left: 1rem;
    }

    li {
      margin-bottom: 0.5rem;
    }
  }
`;
